import React from "react";
import { FaTimes } from "react-icons/fa";
import DOMPurify from "dompurify";
import { useBanners } from "./useBanners";

const ALLOWED_STYLES = ["info", "warning", "error", "success"];

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ["p", "a", "b", "i", "em", "strong", "br", "ul", "li", "ol"],
  ALLOWED_ATTR: ["href", "target", "rel"],
};

const sanitizeContent = (content, config = {}) => {
  return DOMPurify.sanitize(content, config);
};

const getSafeStyle = (style) => {
  return ALLOWED_STYLES.includes(style) ? style : "info";
};

const BannerItem = ({ banner, onHide }) => (
  <div
    className={`usa-alert usa-alert--${getSafeStyle(banner.style)}`}
    role="alert"
  >
    <div className="usa-alert__body">
      <h4 className="usa-alert__heading">{sanitizeContent(banner.title)}</h4>
      <div
        className="usa-alert__text"
        dangerouslySetInnerHTML={{
          __html: sanitizeContent(banner.message, {
            ...SANITIZE_CONFIG,
            ADD_ATTR: ["aria-label", "aria-describedby"],
            CUSTOM_ELEMENT_HANDLING: {
              tags: ["a"],
              attributes: {
                href: (value) => {
                  // External links should open in new tab with warning
                  if (value.startsWith("http")) {
                    return {
                      href: value,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": `${value} (Opens in new tab)`,
                    };
                  }
                  return { href: value };
                },
              },
            },
          }),
        }}
      />
      <button
        className="usa-alert__close"
        onClick={() => onHide(banner.id)}
        aria-label={`Close banner: ${sanitizeContent(banner.title)}`}
      >
        <FaTimes size={22} />
      </button>
    </div>
  </div>
);

const Banner = () => {
  const { visibleBanners, hideBanner } = useBanners();

  return (
    <div className="banners">
      {visibleBanners.map((banner) => (
        <BannerItem key={banner.id} banner={banner} onHide={hideBanner} />
      ))}
    </div>
  );
};

export default Banner;
